import { CancelButton, SaveButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { DateInput, TextInput, TextLabel } from '@core/components/Inputs';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { FormControlLabel, Grid, Switch, Typography } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectConta from 'app/components/Select/SelectConta';
import { getCurrency } from 'app/utils/monetarioUtil';
import { isEmpty } from 'app/utils/validation';
import { FormikProvider, useFormik, useFormikContext } from 'formik';
import NP from 'number-precision';
import React, { useEffect, useState } from 'react';
import { FaArrowCircleDown } from 'react-icons/fa';
import { FormaDePagamento } from '../components';
import { ContasPagarAction, useContasPagar } from '../store';
import ContasPagarPagamentosRealizados from './ContasPagarPagamentosRealizados';
import CONTAS_PAGAR_SCHEMA from './ContasPagarSchema';

const calculoValorTotalDespesasSelecionadas = (contas) => {
  let valorTotal = 0;

  contas.forEach((conta) => {
    valorTotal += conta.valorLiquido || 0;
    // FIXME: erro de precisão. Todos do filtro.
  });

  return valorTotal;
};

const RenderInfo = ({ values, variasContas }) => {
  if (variasContas) {
    return (
      <Grid item xs={12}>
        <TextLabel
          fullWidth
          id="valorPago"
          label="Valor total das despesas selecionadas (R$)"
          value={getCurrency(calculoValorTotalDespesasSelecionadas(values.contas)).replace('R$', '')}
        />
      </Grid>
    );
  }
  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextLabel id="fornecedor" label="Fornecedor" fullWidth value={values?.contas[0].fornecedor?.pessoa?.nome} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextLabel
          id="valorLiquido"
          label="Valor (R$) "
          fullWidth
          value={getCurrency(values?.contas[0]?.valorLiquido).replace('R$', '')}
        />
      </Grid>
    </>
  );
};
const FormBaixa = () => {
  const formik = useFormikContext();

  const [expanded, setExpanded] = useState('');

  const [, setBaixaEmParcelas] = useState(false);

  const variasContas = formik.values?.contas.length > 1;

  const disabledSeForBaixaParcial =
    formik.values?.contas[0]?.situacao === 'PARCIAL' ||
    formik.values?.ids?.some((contaReceber) => contaReceber.situacao === 'PARCIAL');

  const handleExpandedChange = (key, value) => {
    if (value) {
      setExpanded(key);
    } else {
      setExpanded(false);
    }
  };

  if (!formik.values?.baixa?.acrescimosDescontos) {
    delete formik.values.baixa.juros;
    delete formik.values.baixa.multa;
    delete formik.values.baixa.desconto;
  }

  useEffect(() => {
    let valorEmAberto = 0;
    for (let i = 0; i < formik?.values?.contas[0]?.baixas?.length; i++) {
      const baixa = formik.values.contas[0].baixas[i];
      let correcoes = (baixa?.juros?.valor || 0) + (baixa?.multa?.valor || 0) - (baixa?.desconto?.valor || 0);
      valorEmAberto = valorEmAberto + correcoes - (baixa?.valorPago || 0);
    }

    formik.values.valorEmAbertoBaixasAnteriores = valorEmAberto + formik.values?.contas[0]?.valorLiquido;

    if (formik.values?.valorEmAbertoBaixasAnteriores === formik.values?.contas[0]?.valorLiquido) {
      formik.setFieldValue('baixa.valorPago', calcularValorPago(formik.values));
    } else {
      formik.setFieldValue('baixa.valorPago', formik.values?.valorEmAbertoBaixasAnteriores);
    }

    verificarBaixaEmParcelas();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const baixaValorPago = formik.values?.baixa?.valorPago;
  useEffect(() => {
    const valorEmAbertoParcelasAnteriores = formik.values?.valorEmAbertoBaixasAnteriores || 0;
    const valorPago = baixaValorPago || 0;

    const valorEmAberto = valorEmAbertoParcelasAnteriores - valorPago;

    formik.setFieldValue('baixa.valorEmAberto', valorEmAberto);
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baixaValorPago]);

  const verificarBaixaEmParcelas = () => {
    if (formik.values?.baixa?.parcelas?.length > 0) {
      for (var i = 0; i < formik.values?.baixa?.parcelas?.length; i++) {
        if (formik.values?.baixa?.parcelas[i]?.baixas?.length > 0) {
          setBaixaEmParcelas(true);
          break;
        }
      }
    }
  };

  const calcularValorPago = (values) => {
    const valorLiquido = values.contas[0]?.valorLiquido || 0;

    return valorLiquido;
  };

  const getValorPagoAcrescimoDescontos = (values) => {
    const valorPago = values.baixa?.valorPago || 0;
    const juros = values.baixa?.juros?.valor || 0;
    const multa = values.baixa?.multa?.valor || 0;
    const desconto = values.baixa?.desconto?.valor || 0;

    return getCurrency(NP.minus(NP.minus(NP.plus(NP.plus(valorPago, juros), multa), desconto), 0));
  };

  if (isEmpty(formik.values?.baixa?.conta)) {
    delete formik.values.baixa.conta;
  }

  const exibirValorEmAberto = (values) => {
    return values?.baixa?.valorEmAberto > 0 ? true : false;
  };

  return (
    <Grid container spacing={3}>
      <RenderInfo values={formik.values} variasContas={variasContas} />
      <Grid item xs={12} sm={6}>
        <DateInput
          fullWidth
          id="baixa.dataPagamento"
          label="Data do pagamento *"
          value={formik.values?.baixa?.dataPagamento || null}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={formik.touched?.baixa?.dataPagamento}
          error={formik.errors?.baixa?.dataPagamento}
          helperText={formik.errors?.baixa?.dataPagamento}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DateInput
          fullWidth
          id="baixa.dataLiquidacao"
          label="Data da liquidação *"
          value={formik.values?.baixa?.dataLiquidacao || null}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={formik.touched?.baixa?.dataLiquidacao}
          error={formik.errors?.baixa?.dataLiquidacao}
          helperText={formik.errors?.baixa?.dataLiquidacao}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectConta
          id="baixa.conta"
          name="baixa.conta"
          fullWidth
          label="Conta"
          value={formik.values?.baixa?.conta}
          onChange={(event) => {
            formik.handleChange(event);
            formik.handleChange({
              target: {
                id: 'baixa.formaPagamento',
                value: undefined,
              },
            });
          }}
          onBlur={formik.handleBlur}
          required
          touched={formik.errors?.baixa?.conta}
          error={formik.errors?.baixa?.conta && formik.submitCount > 0 ? formik.errors?.baixa?.conta : false}
          disabled={disabledSeForBaixaParcial}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormaDePagamento
          id="baixa.formaPagamento"
          value={formik.values?.baixa?.formaPagamento}
          handleChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          tipoConta={formik.values?.baixa?.conta?.tipo}
          required
          touched={formik.errors?.baixa?.formaPagamento}
          error={
            formik.errors?.baixa?.formaPagamento && formik.submitCount > 0
              ? formik.errors?.baixa?.formaPagamento
              : false
          }
        />
      </Grid>
      {formik.values?.baixa?.formaPagamento === 'CHEQUE' && (
        <Grid item xs={12} sm={6}>
          <TextInput
            fullWidth
            required
            id="baixa.numeroCheque"
            label="Número do cheque"
            value={formik.values?.baixa?.numeroCheque}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength={20}
            pattern={/^\d*$/}
            touched={formik.errors?.baixa?.numeroCheque}
            error={formik.errors?.baixa?.numeroCheque}
          />
        </Grid>
      )}
      {!variasContas && (
        <>
          <Grid item xs={12} sm={6}>
            <InputMonetario
              fullWidth
              required
              id="baixa.valorPago"
              label="Valor (R$)"
              handleBlur={formik.handleBlur}
              value={formik.values?.baixa?.valorPago || 0}
              touched={formik.errors?.baixa?.valorPago}
              error={
                formik.errors?.baixa?.valorPago && formik.submitCount > 0 ? formik.errors?.baixa?.valorPago : false
              }
              helperText={formik.errors?.baixa?.valorPago}
              handleChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              label="Incluir acréscimos e descontos"
              control={
                <Switch
                  id="baixa.acrescimosDescontos"
                  name="baixa.acrescimosDescontos"
                  value={formik.values?.acrescimosDescontos}
                  checked={formik.values?.acrescimosDescontos}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  color="primary"
                />
              }
            />
          </Grid>
          {formik.values?.baixa?.acrescimosDescontos && (
            <>
              <Grid item xs={12} sm={6}>
                <InputMonetario
                  fullWidth
                  id="baixa.juros.valor"
                  label="Juros (R$)"
                  onBlur={formik.handleBlur}
                  value={formik.values?.baixa?.juros?.valor}
                  handleChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputMonetario
                  fullWidth
                  id="baixa.multa.valor"
                  label="Multa (R$)"
                  onBlur={formik.handleBlur}
                  value={formik.values?.baixa?.multa?.valor}
                  handleChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputMonetario
                  fullWidth
                  id="baixa.desconto.valor"
                  label="Desconto (R$)"
                  onBlur={formik.handleBlur}
                  value={formik.values?.baixa?.desconto?.valor}
                  handleChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <ReadOnlyInput
                  fullWidth
                  id="baixa.valorPagoAcrescimoDescontos"
                  label="Valor Pago (R$)"
                  value={getValorPagoAcrescimoDescontos(formik.values)}
                />
              </Grid>
            </>
          )}
          {exibirValorEmAberto(formik.values) && (
            <Grid item xs={12} sm={6}>
              <ReadOnlyInput
                fullWidth
                id="baixa.valorEmAberto"
                label="Valor em aberto (R$)"
                value={
                  formik.values?.baixa?.valorEmAberto === 0 ? '-' : getCurrency(formik.values?.baixa?.valorEmAberto)
                }
              />
            </Grid>
          )}
          {formik.values?.baixa?.valorEmAberto < 0 && (
            <Grid item xs={12} sm={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography style={{ fontSize: 15, fontWeight: 500, color: '#f00' }}>
                  Diferença: {getCurrency(formik.values?.baixa?.valorEmAberto)}
                </Typography>
              </Grid>
            </Grid>
          )}
        </>
      )}
      <>
        <Grid item xs={12}>
          <FormControlLabel
            label="Emitir recibo"
            control={
              <Switch
                id="baixa.emitirRecibo"
                name="baixa.emitirRecibo"
                value={formik.values?.emitirRecibo}
                checked={formik.values?.emitirRecibo}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                color="primary"
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            label="Emitir detalhes da baixa"
            control={
              <Switch
                id="baixa.emitirDetalhes"
                name="baixa.emitirDetalhes"
                value={formik.values?.emitirDetalhes}
                checked={formik.values?.emitirDetalhes}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                color="primary"
              />
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          {formik.values?.contas[0]?.baixas?.length > 0 && (
            <CustomExpandedPanel
              title="Pagamentos realizados"
              expanded={expanded === 'pagamentos'}
              onChange={(_, value) => handleExpandedChange('pagamentos', value)}
            >
              <ContasPagarPagamentosRealizados
                baixas={formik.values?.contas[0]?.baixas || undefined}
                showTitle={false}
                showCancelarBaixa={false}
                showParcelas={false}
              />
            </CustomExpandedPanel>
          )}
        </Grid>
      </>
    </Grid>
  );
};

const ContasPagarBaixa = () => {
  const [state, dispatch] = useContasPagar();
  const { registro, baixarConta, requestParams, filtroAvancado } = state;

  const onSubmitForm = (values) => {
    if (!(formik.values?.baixa?.valorEmAberto < 0)) {
      ContasPagarAction.baixarContas(dispatch, values, requestParams, filtroAvancado);
    }
  };

  const formik = useFormik({
    initialValues: registro,
    onSubmit: onSubmitForm,
    validateOnChange: true,
    validationSchema: CONTAS_PAGAR_SCHEMA.BAIXA,
  });

  useEffect(() => {
    if (baixarConta) {
      formik.resetForm({
        values: registro,
      });
    }
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baixarConta]);

  const handleCancelar = () => ContasPagarAction.fecharModalCadastro(dispatch, formik.dirty);

  return (
    <SimpleDialog open={baixarConta} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        {baixarConta && (
          <FormDialogContent
            onSubmit={formik.handleSubmit}
            header={{
              title: 'Baixar conta',
              icon: <FaArrowCircleDown />,
              toolbar: (
                <>
                  <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                    Cancelar
                  </CancelButton>
                  <SaveButton color="buttonSave" type="submit">
                    Baixar
                  </SaveButton>
                </>
              ),
            }}
            content={<FormBaixa />}
            // contentStyle={{ padding: 0 }}
          />
        )}
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ContasPagarBaixa;
